import { Controller } from "@hotwired/stimulus"

// Controls duration days field visibility when duration type is "otro".
export default class extends Controller {
  static targets = ["durationTypeSelect", "durationDaysSection"]
  static values = {
    initialDurationType: { type: String, default: "" }
  }

  connect() {
    this.updateDurationDaysVisibility()
  }

  onDurationTypeChange() {
    this.updateDurationDaysVisibility()
  }

  updateDurationDaysVisibility() {
    if (!this.hasDurationDaysSectionTarget) return

    const durationType = this.selectedDurationType()
    if (durationType === "otro") {
      this.durationDaysSectionTarget.classList.remove("hidden")
    } else {
      this.durationDaysSectionTarget.classList.add("hidden")
    }
  }

  selectedDurationType() {
    const select = this.hasDurationTypeSelectTarget ? this.durationTypeSelectTarget : this.element.querySelector('select[name="plan[duration_type]"]')
    return select?.value || this.initialDurationTypeValue || ""
  }
}
